import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "lznelist_all acea-row row-top"
};
const _hoisted_3 = {
  class: "lznelist_left"
};
const _hoisted_4 = {
  class: "lzrcz_title"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "lznelist_right acea-row row-between-wrapper"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "shop_pic acea-row row-center-wrapper"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "shop_name acea-row row-center-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu
  }, null, 8, ["xzmenu"]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "news_postion"
  }, "当前位置： 主页 > 资讯列表", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($data.arcinfo.title), 1), _createElementVNode("div", {
    class: "lzrcz_content",
    innerHTML: $data.arcinfo.content
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "shop_title"
  }, "热门文章", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.news_list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "shop_list martopershi",
      onClick: $event => $options.goxinwen(item.id, 4)
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
      src: item.image_input
    }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.short_title), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "shop_btn acea-row row-center-wrapper"
    }, [_createElementVNode("div", {
      class: "shop_chakan acea-row row-center-wrapper"
    }, " 立即查看 ")], -1))], 8, _hoisted_7);
  }), 256))])]), _createVNode(_component_zrcfooter)]);
}